import styled from "styled-components";
import { GRAY_500, GRAY_900 } from "../../Config/colors";
import Colors from "../../Constant/Colors";
import { STYLES } from "../../Constant/Theme";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

`;
export const IllustrationColumn = styled.div`
  min-width: 360px;
  width: 50vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to top, #017a73 20%, #374557 100%);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  @media only screen and (max-width: 600px) {
    display: none;
    /* Styles for screens 600px and larger */
  }

  /* @media only screen and (min-width: 768px) {
    /* Styles for screens 768px and larger */
  }

  @media only screen and (min-width: 1024px) {
    /* Styles for screens 1024px and larger */
  } */
  /* padding: 1rem; */
`;

export const MobileHeader = styled.div`
  @media only screen and (min-width: 600px) {
    display: none;
  }
  @media only screen and (max-width: 600px) {
    display: block;
    position: absolute;
    width: 100%;
    padding-top: 15px;
    padding-bottom: 15px;
    background-color: ${Colors.primary};
    ${STYLES.HorizontalAlign}
  }
`;
export const ParentContainer = styled.div`
  display: flex;
  flex-direction:column ;
  justify-content: center;  /* Center horizontally */
  align-items: center;  /* Center vertically */
  width: 50vw;
  height: 100vh;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const AuthFormContainer = styled.div`
  min-width: 360px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;  /* Center vertically */

  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  @media only screen and (max-height: 850px) {
    justify-content: flex-start;  /* Align items to the start if height is less than 850px */
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;


export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const GrayText = styled.p`
  font-weight: normal;
  font-size: 14px;
  /* line-height: 20px; */
  color: ${GRAY_500};
  margin-bottom: 0;
`;
export const UsersList = styled.div`
  ${STYLES.HorizontalAlign};
  margin-bottom: 20px;
`;
export const EachUser = styled.div`
  ${STYLES.HorizontalAlign};
  margin: 10px;
  padding: 10px;
  border-radius: 10px;
  background-color: ${(props) =>
    props.isSelected ? Colors.hoverColor : Colors.whiteThemeColor};
  &:hover {
    background-color: ${Colors.hoverColor}; /* For example, changing the background color */
    cursor: pointer; /* Change cursor to pointer on hover */
  }
`;
export const Heading = styled.span`
  font-weight: bold;
  font-size: 28px;
  letter-spacing: -0.02em;
  color: ${GRAY_900};
  margin-bottom: 10px;
`;

export const Description = styled.span`
  font-weight: normal;
  font-size: 12px;
  /* line-height: 24px; */
  color: ${GRAY_500};
  margin-bottom: 1rem;
`;
